module.exports = __webpack_public_path__ + "static/bm-983adcb8efbe10e9612be5164d72303b.svg";